import { render } from "./ResolvingLimitationStepTwo.vue?vue&type=template&id=856b0f1e&scoped=true&ts=true"
import script from "./ResolvingLimitationStepTwo.vue?vue&type=script&lang=ts"
export * from "./ResolvingLimitationStepTwo.vue?vue&type=script&lang=ts"

import "./ResolvingLimitationStepTwo.vue?vue&type=style&index=0&id=856b0f1e&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-856b0f1e"]])

export default __exports__